const data = [
    {
        title: 'Meta Reality Labs | AR/VR Research & Development',
        subtitle: 'Since:',
        image: '/project_title_cards/code_projects/orion.webp',
        link: 'https://www.meta.com/ai-glasses/',
        date: '2022-08-01',
        desc: 'Gameplay engineer and prototyper working on R&D for next generation smartglasses (Rayban Metas). Previously worked on input interactions for AR glasses.'
    },
    {
        title: 'Tempus',
        subtitle: 'Video Game, Puzzle Platformer | Awarded GDIAC Digital Showcase Most Polished Game',
        image: '/project_title_cards/code_projects/tempus_banner.png',
        date: '2020-05-01',
        link: "https://github.com/clillianhong/tempus",
        desc:
          'Project lead for Tempus, a fast-paced puzzle platformer that launches players into the heat of battle in a beautiful, strange fantasy world. '
          + ' Tempus won the award for Most Polished Game at the 2020 Game Design Initiative at Cornell (GDIAC) Showcase.'
    },
    {
        title: 'Meta Horizon',
        subtitle: 'VR Gaming | Internship',
        image: '/project_title_cards/code_projects/horizon_worlds.webp',
        date: '2021-06-01',
        link: "",
        desc:
          'Integrated hand tracking as a first class input system and prototyped a VR hands-only locomotion demo within Meta Horizon, a first party social VR game.'
    },
    {
        title: 'Amazon',
        subtitle: 'ML infra | Internship',
        image: '/project_title_cards/code_projects/amazon.jpg',
        date: '2020-06-01',
        link: "",
        desc:
          'Interned on the Amazon photos computer vision team, augmenting their facial recognition pipeline with better e2e integration and visualization.'
    },
]

export default data;